import React, { createContext, useState, useContext, useEffect } from 'react';

export const CartContext = createContext();

// Proveedor para envolver la aplicación
export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartSummary, setCartSummary] = useState({
    subtotal: 0,
    descuentoCupon: 0,
    costoTotal: 0,
    cartItems: [],
    cantidades: [],
    porcentajeDescuento: 0
  });

  useEffect(() => {
    const subtotal = cartItems.reduce((acc, item) => {
      const precio = parseFloat(item.productoPrecio) || 0;
      return acc + precio * item.cantidad;
    }, 0);

    const descuento = ((cartSummary.porcentajeDescuento || 0) / 100) * subtotal;
    const costoTotal = subtotal - descuento;

    setCartSummary(prev => ({
      ...prev,
      subtotal,
      costoTotal,
      descuentoCupon: descuento
    }));
  }, [cartItems, cartSummary.porcentajeDescuento]);

  const addToCart = (item) => {
    setCartItems((prevItems) => {
      const itemIndex = prevItems.findIndex(cartItem => cartItem.productoId === item.productoId);
      if (itemIndex > -1) {
        const updatedItems = [...prevItems];
        updatedItems[itemIndex].cantidad += item.cantidad;
        return updatedItems;
      } else {
        return [...prevItems, item];
      }
    });
  };

  const removeFromCart = (itemId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.productoId !== itemId));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  return (
    <CartContext.Provider value={{
      cartItems,
      setCartItems,
      addToCart,
      removeFromCart,
      clearCart,
      cartSummary,
      setCartSummary
    }}>
      {children}
    </CartContext.Provider>
  );
};